import React, { useEffect, useMemo } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionSucursal} from '../../../../actions/action-creators'
import {isNullOrEmpty} from '../../../../utils/strings.utils'
import { encontrarSerieActiva, encontrarSucursalConDocs } from '../../../../utils/invoice/sucursales_docs'
import { comprobanteRetencionClearAll, comprobanteRetencionSetCatalogoSerie } from '../../../../actions/comprobante-retencion/comprobanteRetencionEmision.actions'
import { comprobanteRetencionFormSucursalHandleChange } from '../../../../actions/comprobante-retencion/comprobanteRetencionSucursal.actions'
import SearchSelect from '../../../../components/Inputs/SearchSelect'
import { useHistory } from 'react-router-dom'
import { showMessageSucursalVacia } from '../../../../actions/userLogin.actions'

const CREDatosSucursal = () => {
  const history = useHistory();
  const {activeDoc} = useSelector((state: State) => state.documentos)
  const {sucursalesCargadas} = useSelector((state: State) => state.comprobanteRetencion)
  const sucursales = useSelector((state: State) => state.comprobanteRetencion.catalogoSucursal)
  const series = useSelector((state: State) => state.comprobanteRetencion.catalogoSerie)
  const form = useSelector((state: State) => state.comprobanteRetencion.formSucursal)
  const errors = useSelector((state: State) => state.comprobanteRetencion.errorsFormSucursal)
  const dispatch = useDispatch()
  const acciones = bindActionCreators(actionComprobanteRetencionSucursal, dispatch)

  useEffect(() => {
    if (sucursales.length > 0) {
      try {
        const sucursalDefault = sucursales[0];
        const serieDefault = sucursalDefault?.Documento[0];
        
        if (sucursalDefault && serieDefault) {
          dispatch(comprobanteRetencionSetCatalogoSerie(sucursalDefault.Documento));
          dispatch(comprobanteRetencionFormSucursalHandleChange({
            'sucursal': sucursalDefault.idsucursal,
            'serie': serieDefault.idsucursaldocumento,
            'datosSerie': serieDefault,
          }));
        } else {
          dispatch(comprobanteRetencionFormSucursalHandleChange({
            'sucursal': '',
            'serie': '',
          }));
        }
      } catch(e) {}
    } else {
      if (sucursalesCargadas) {
        dispatch(showMessageSucursalVacia('Comprobante de retención'));
        history.push('/otros-documentos');
        dispatch(comprobanteRetencionClearAll());
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sucursales]);

  return (
    <form className='form-content' data-wf-page-id='64b58c72be2b65200b1e6fa6' data-wf-element-id='deb0f47f-468f-13fc-f1eb-4d36c39616dc' style={{marginBottom: '5%'}} >
      <div>
        <h3 className='card-title l'>Sucursal y Serie</h3>
      </div>
      <div className='form-separator'></div>
      <div className='w-layout-hflex h-inputs'>
        <div className='label-input'>
          <label htmlFor='sucursal' className='field-label m'>
            Sucursal<span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect disabled={true} defaultValue={null} data={sucursales} value={form.sucursal} keyNameText='nombre' keyNameValue='idsucursal' placeholder='Sucursal' name='sucursal' onChange={(value: any) => {acciones.comprobanteRetencionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'sucursal'}}) ; acciones.comprobanteRetencionFormSucursalOnBlur({target: {value: value?.value, name: 'sucursal'}})}}/>
          {errors.sucursal && <p className='alert s'>{errors.sucursal}</p>}
        </div>
        <div className='label-input'>
          <label htmlFor='serie' className='field-label m'>
            Serie<span style={{color: 'red'}}>*</span>
          </label>
          <SearchSelect disabled={!sucursalesCargadas} defaultValue={null} data={series.map((serie) => {return({...serie, serie_numero: `${serie?.serie}-${serie?.numeroactual}`})})} value={form.serie} keyNameText='serie_numero' keyNameValue='idsucursaldocumento' placeholder='Serie' name='serie' onChange={(value: any) => {acciones.comprobanteRetencionFormSucursalHandleChangeInput({target: {value: value?.value, name: 'serie'}}) ; acciones.comprobanteRetencionFormSucursalOnBlur({target: {value: value?.value, name: 'serie'}})}}/>
          {errors.serie && <p className='alert s'>{errors.serie}</p>}
        </div>
      </div>
      <div className='separador'></div>
    </form>
  )
}

export default CREDatosSucursal
